export default "__VITE_ASSET__BlZZyF8Q__"